import { paletteHelper, spacingHelper, mediaHelper } from '@property.com.au/ui-kit';
import crossSvg from '../../assets/cross.svg';
import { css } from 'styled-components';

const CLOSE_BUTTON_OFFSET = spacingHelper('small');
const CLOSE_BUTTON_SCALING = '80%';
const CLICKABLE_SPACE_AROUND_CLOSE_BUTTON = 8;

export const modalCloseButton = css`
  scale: ${CLOSE_BUTTON_SCALING};
  top: ${CLOSE_BUTTON_OFFSET};
  right: ${CLOSE_BUTTON_OFFSET};
  border-radius: 50%;
  position: absolute;

  background: no-repeat center/50% url(${crossSvg});
  svg {
    /* hides the default dialog close icon */
    display: none;
  }

  &:hover {
    background-color: ${paletteHelper('backgroundSecondaryBase')};
  }

  &:focus {
    background-color: ${paletteHelper('backgroundHoveredPrimary')};
  }

  ${mediaHelper('mobile')} {
    &::after {
      /* Expands the clickable area around close button for better touch experience  */
      /* https://front-back.com/expand-clickable-areas-for-a-better-touch-experience */
      content: '';
      inset: -${CLICKABLE_SPACE_AROUND_CLOSE_BUTTON}px;
      position: absolute;
      border-radius: 50%;
    }
  }
`;
